/*jshint esversion: 8*/
/* API calls for contact-service components.
 * HISTORY:Implemented logout+Removed finally clauses
 * 04/21/22(B0.23): Uncommented getImport() method.
 * 04/19/22(B0.22): Added predefined filter methods.
 * 03/31/22(B0.21): Added remote access methods.
 * 03/25/22(B0.20): in getOffersCount(), modified empty filter to increase the speed of the query (this was moved from CsDocuments).
 * 03/08/22(B0.19): In deleteOffers(), passed deletedCount.
 * 03/07/22(B0.18): Added getDeletesCount() and getDeletes().
 * 03/03/22(B0.17): Added deleteOffers().
 * 09/22/21(B0.16): Modified getOffersCount() and getOffers() to handle dice & slice (aggregate query).
 * 07/26/21(B0.15): Added getImportsCount() & getExportsCount() and modified getImports() & getExports() to accept filter param +
 *    Replaced this.jwt.aid with aid + In getImports() managed to accept empty params.
 * 06/29/21(B0.14): Added exports methods.
 * 06/22/21(B0.13): Fixed a bug in getIndexes() that didn't parse the 2nd field properly.
 * 06/22/21(B0.12): Fixed a bug in createIndex() that didn't add the 2nd field to postData.
 * 06/22/21(B0.11): Modified getIndexes() to convert response data to the class structure.
 * 06/21/21(B0.10): Added Index methods: getIndexes(), createIndex() and deleteIndex().
 * 06/08/21(B0.9): Modified getOffers() to distinguish existence of $group differently.
 * 05/12/21(B0.8): Fixed a bug in getOffers() that didn't build the url properly.
 * 04/28/21(B0.7): Fixed bug with location filter.
 * 04/28/21(B0.6): Applied changed to support groupby.dateType.
 * 04/23/21(B0.5): Built a different url for aggregate + Implemented logic to parse $group for testing purposes.
 * 04/20/21(B0.4): Implemented regex filter for json-server.
 * 04/19/21(B0.3): Added getOffersCount() function.
 * 03/19/21(B0.2): Commented sleep() functions and removed mixin.
 * 10/21/20(B0.1): Creation date.
 */

import axios from 'axios';
// import { Collection } from 'json-aggregate';
// import jsonAggregate from 'json-aggregate';
import { sleep } from '../mixins/bt-mixin.js';

let _debug;

function _log(msg) {
   if (_debug) {
      console.log(`-----cs-api-service B0.23 says => ${msg}`);
      // alert(`-----cs-api-service B0.23 says => ${msg}`);
   }
}

function _initResult() {
   // return {
   //    data: data || null,
   //    message: message || null
   // };
   return {
      data: null,
      message: null,
      logout: false
   };
}

// function _parseError(error, displayError =true) {
//    _log('in _parseError(): error=' + JSON.stringify(error));
//    let errMsg;
//    if (error.response)
//       errMsg = JSON.stringify(error.response.data) + ' (' + error.response.status + ')';
//    else if (error.request)
//       errMsg = JSON.stringify(error.request);//error.request.data + ' (' + error.request.status + ')';
//    else
//       errMsg = error.message;

//    if (displayError)
//       alert(errMsg);

//    return errMsg;
// }
function _parseError(error, data =null, displayError =true) {
   _log(`in _parseError(): error=${JSON.stringify(error)}, data=${data}`);
   const result = _initResult();
   if (error.response) {
      if (error.response.status === 401)  //unauthorized
         result.logout = true;
      else {
         if (error.response.status === 404)  //not found
            result.data = data;
         if (result.data === null)
            result.message = `${JSON.stringify(error.response.data)} (status=${error.response.status})`;
      }
   } else if (error.request)
      result.message = JSON.stringify(error.request); //error.request.data + ' (' + error.request.status + ')';
   else
      result.message = error.message;

   if (displayError && result.message)
      alert(result.message);

   return result;
}

function _parseMatchFilter(filter) {
   _log('in _parseMatchFilter(): filter=' + JSON.stringify(filter));
   const match = filter.standard[0].$match;
   let params = '';

   for (const key in match) {
      // alert('key=' + key);
      if (match.hasOwnProperty(key) && key != 'location') {
         const val = match[key];
         if (typeof val === 'object') {
            // alert('val=' + JSON.stringify(val));
            for (const operator in val) {
               if (operator != '$in' && operator != '$nin' && operator != '$regex')
                  params += '&' + key + operator.replace('$', '_') + '=' + val[operator];
               else if (operator != '$regex')
                  val[operator].forEach(v => {
                     params += '&' + key + '=' + v;
                  });
            }
         } else 
            params += '&' + key + '=' + val;
      }
   }

   // alert('in _parseMatchFilter(): params=' + JSON.stringify(params));
   return params;
}

function _getActualData(data, filter) {
   _log(`in _getActualData(): data=${JSON.stringify(data)}\n\tfilter=${JSON.stringify(filter)}`);
   let actualData = [];
   data.forEach(d => {
      const offer = {};
      filter.columns.forEach(col => {
         offer[col] = d[col];
      });
      offer._id = d._id;
      actualData.push(offer);
   });

   if (filter.standard) {
      // const { Collection } = require('json-aggregate');
      // let collection;
      
      // const jsonAggregate = require('json-aggregate')
      // const collection = jsonAggregate.create(myJsonData)

      filter.standard.forEach(filter => {
         if (filter.$match) {
            const matches = filter.$match;
            // alert('matches=' + JSON.stringify(matches));
            for (const key in matches) {
               // alert('key=' + key);
               if (matches.hasOwnProperty(key) && key != 'location') {
                  const val = matches[key];
                  if (typeof val === 'object') {
                     // alert('val=' + JSON.stringify(val));
                     for (const operator in val) {
                        if (operator === '$regex')
                           actualData = actualData.filter(d => d[key].match(new RegExp(val[operator], "i")));
                     }
                  }
               }
            }
         } else if (filter.$group) {
            if (Object.keys(filter.$group).length === 1)
               actualData = [
                  { _id: { Product: "Product1" } },
                  { _id: { Product: "Product2" } },
                  { _id: { Product: "Product3" } },
                  { _id: { Product: "Product3 " } },
                  { _id: { Product: "Product4 " } },
                  { _id: { Product: "Product5 " } },
                  { _id: { Product: "Product6 " } }
               ];
            else {
               const key = Object.keys(filter.$group)[1];
               // alert('key in actual data:'+key);
               switch (key) {
                  case "Count":
                     actualData = [
                        // { _id: { Is_Bundle: false }, Count: 498 },
                        // { _id: { Is_Bundle: true }, Count: 500 }
                        //from Aref
                        {"_id": { "Event Code": "auth-succeed"}, "Count": 2 },
                        {"_id":{ "Event Code": "30503"}, "Count": 2 },
                        {"_id":{"Event Code":"form-submit"},"Count":2}                        
                     ];
                     actualData = [
                        { _id: { Product: "Product1" }, Count: 847 },
                        { _id: { Product: "Product2" }, Count: 136 },
                        { _id: { Product: "Product3" }, Count: 14 },
                        { _id: { Product: "Product3 " }, Count: 1 }
                     ];
                     actualData = [];
                     // for (let index = 1; index <= 31; index++) {
                     //    actualData.push({ _id: { dayOfMonth: index }, Count: index });
                     // }
                     // for (let index = 1; index <= 12; index++) {
                     //    actualData.push({ _id: { month: index }, Count: index });
                     // }
                     // for (let index = 1; index <= 7; index++) {
                     //    actualData.push({ _id: { dayOfWeek: index }, Count: index });
                     // }

                     // actualData = [
                     //    { _id: { 'dayOfWeek': 2, Product: 'Product1' }, Count: 142 },
                     //    { _id: { 'dayOfWeek': 3, Product: 'Product1' }, Count: 117 },
                     //    { _id: { 'dayOfWeek': 5, Product: 'Product1' }, Count: 136 },
                     //    { _id: { 'dayOfWeek': 6, Product: 'Product1' }, Count: 125 },
                     //    { _id: { 'dayOfWeek': 2, Product: 'Product2' }, Count: 24 },
                     //    { _id: { 'dayOfWeek': 4, Product: 'Product2' }, Count: 21 },
                     //    { _id: { 'dayOfWeek': 6, Product: 'Product3' }, Count: 1 },
                     //    { _id: { 'dayOfWeek': 7, Product: 'Product3' }, Count: 2 }
                     // ];

                     actualData = [
                        { _id: { payment_type: 'Amex', event_code: '20102' }, count: 53 },
                        { _id: { payment_type: 'Amex', event_code: '20103' }, count: 20 },
                        { _id: { payment_type: 'Amex', event_code: '20105' }, count: 13 },
                        { _id: { payment_type: 'Diners', event_code: '20102' }, count: 45 },
                        { _id: { payment_type: 'Diners', event_code: '20103' }, count: 24 },
                        { _id: { payment_type: 'Diners', event_code: '20105' }, count: 5 },
                        { _id: { payment_type: 'Mastercard', event_code: '20102' }, count: 159 },
                        { _id: { payment_type: 'Mastercard', event_code: '20103' }, count: 78 },
                        { _id: { payment_type: 'Mastercard', event_code: '20105' }, count: 34 },
                        { _id: { payment_type: 'Visa', event_code: '20102' }, count: 286 },
                        { _id: { payment_type: 'Visa', event_code: '20103' }, count: 149 },
                        { _id: { payment_type: 'Visa', event_code: '20105' }, count: 56 }
                     ];

                     // actualData = [
                     //    { _id: { dayOfWeek: 4, event_code: '20102' }, count: 543 },
                     //    { _id: { dayOfWeek: 4, event_code: '20103' }, count: 271 },
                     //    { _id: { dayOfWeek: 4, event_code: '20105' }, count: 108 },
                     //    { _id: { dayOfWeek: 6, event_code: '20102' }, count: 100 },
                     //    { _id: { dayOfWeek: 6, event_code: '20103' }, count: 150 },
                     //    { _id: { dayOfWeek: 6, event_code: '20105' }, count: 11 }
                     // ];

                     // actualData = [
                     //    { _id: { event_code: '20102' }, count: 1 },
                     //    { _id: { event_code: '20103' }, count: 1 },
                     //    { _id: { event_code: '20105' }, count: 1 }
                     // ];

                     // alert('actualData='+JSON.stringify(actualData));
                     // { _id: { month: 1 }, Count: 995 },
                     // { _id: { month: 2 }, Count: 3 }
                     
                     //from Aref: 3/10/22
                     actualData = [
                        {"_id": { "Event Code": "auth-succeed"}, "Count": 2 },
                        {"_id": { "Event Code": "30503"}, "Count": 2 },
                        {"_id": {"Event Code":"form-submit"}, "Count":2}                        
                     ];
                     break;
                  case "Total":
                     actualData = [
                        { _id: { State: "Central Bohemia" }, Total: 489600 },
                        { _id: { State: "Sicilia" }, Total: 16200 },
                        { _id: { State: "Aargau" }, Total: 4800 },
                        { _id: { State: "Black River" }, Total: 3600 },
                        { _id: { State: "Prague" }, Total: 2100 },
                        { _id: { State: "Izmir" }, Total: 1200 }
                     ];

                     actualData = [
                        { _id: { hour: 0, payment_type: 'Amex' }, Total: 7200 },
                        { _id: { hour: 0, payment_type: 'Diners' }, Total: 3600 },
                        { _id: { hour: 0, payment_type: 'Mastercard' }, Total: 7200 },
                        { _id: { hour: 0, payment_type: 'Visa' }, Total: 35100 },
                        { _id: { hour: 1, payment_type: 'Amex' }, Total: 4800 },
                        { _id: { hour: 1, payment_type: 'Diners' }, Total: 7200 },
                        { _id: { hour: 1, payment_type: 'Mastercard' }, Total: 8400 },
                        { _id: { hour: 1, payment_type: 'Visa' }, Total: 38400 },
                        { _id: { hour: 2, payment_type: 'Amex' }, Total: 7200 },
                        { _id: { hour: 2, payment_type: 'Diners' }, Total: 3600 },
                        { _id: { hour: 2, payment_type: 'Mastercard' }, Total: 10800 },
                        { _id: { hour: 2, payment_type: 'Visa' }, Total: 40600 }
                     ];
                     break;
                  case "Average":
                     // actualData = [
                     //    { _id: { Payment_Type: 'Amex'}, Average: 1717.2727272727273 },
                     //    { _id: { Payment_Type: 'Mastercard'}, Average: 1655.0541516245487 },
                     //    { _id: { Payment_Type: 'Visa'}, Average: 1627.1072796934866 },
                     //    { _id: { Payment_Type: 'Diners'}, Average: 1503.370786516854 }
                     // ];
                     actualData = [
                        { _id: { year: 2009, Payment_Type: 'Amex'}, Average: 1717.2727272727273 },
                        { _id: { year: 2009, Payment_Type: 'Mastercard'}, Average: 1655.0541516245487 },
                        { _id: { year: 2009, Payment_Type: 'Visa'}, Average: 1627.1072796934866 },
                        { _id: { year: 2009, Payment_Type: 'Diners'}, Average: 1503.370786516854 }
                     ];
                     break;
                  case "Maximum":
                     actualData = [
                        { _id: { Country: 'Czech Republic' }, Maximum: 3600 },
                        { _id: { Country: 'Malta' }, Maximum: 3600 },
                        { _id: { Country: 'Greece' }, Maximum: 1200 },
                        { _id: { Country: 'Guatemala' }, Maximum: 1200 }
                     ];
                     break;
                  case "Minimum":
                     actualData = [
                        { _id: { Product: 'Product1', Payment_Type: 'Amex' }, Minimum: 105800 },
                        { _id: { Product: 'Product1', Payment_Type: 'Diners' }, Minimum: 97200 },
                        { _id: { Product: 'Product1', Payment_Type: 'Mastercard' }, Minimum: 280550 },
                        { _id: { Product: 'Product1', Payment_Type: 'Visa' }, Minimum: 544850 },
                        { _id: { Product: 'Product2', Payment_Type: 'Amex' }, Minimum: 75600 },
                        { _id: { Product: 'Product2', Payment_Type: 'Diners' }, Minimum: 21600 },
                        { _id: { Product: 'Product3', Payment_Type: 'Amex' }, Minimum: 7500 },
                        { _id: { Product: 'Product3 ', Payment_Type: 'Mastercard' }, Minimum: 7500 }

                        // from RF example
                        // { _id: { Product: 'Product1', Payment_Type: 'Visa' }, Price: 450 },
                        // { _id: { Product: 'Product1', Payment_Type: 'AMEX' }, Price: 350 },
                        // { _id: { Product: 'Product2', Payment_Type: 'Mastercard' }, Price: 250 },
                        // { _id: { Product: 'Product2', Payment_Type: 'Visa' }, Price: 150 }
                     ];
                     break;
                     case "Distinct":
                        actualData = [
                           // { _id: { Product: 'Product1', Payment_Type: 'Amex' }, Minimum: 105800 },
                           // { _id: { Product: 'Product1', Payment_Type: 'Diners' }, Minimum: 97200 },
                           // { _id: { Product: 'Product1', Payment_Type: 'Mastercard' }, Minimum: 280550 },
                           // { _id: { Product: 'Product1', Payment_Type: 'Visa' }, Minimum: 544850 },
                           // { _id: { Product: 'Product2', Payment_Type: 'Amex' }, Minimum: 75600 },
                           // { _id: { Product: 'Product2', Payment_Type: 'Diners' }, Minimum: 21600 },
                           // { _id: { Product: 'Product3', Payment_Type: 'Amex' }, Minimum: 7500 },
                           // { _id: { Product: 'Product3 ', Payment_Type: 'Mastercard' }, Minimum: 7500 }
   
                           // from RF example
                           // { _id: { Product: 'Product1', Payment_Type: 'Visa' }, Price: 450 },
                           // { _id: { Product: 'Product1', Payment_Type: 'AMEX' }, Price: 350 },
                           // { _id: { Product: 'Product2', Payment_Type: 'Mastercard' }, Price: 250 },
                           // { _id: { Product: 'Product2', Payment_Type: 'Visa' }, Price: 150 }

                           { _id: { Product: 'Product1'} },
                           { _id: { Product: 'Product2' } },
                           { _id: { Product: 'Product3' } },
                           { _id: { Product: 'Product3 ' } },
                           { _id: { Product: 'BT' } }

                        ];
                        break;
                     default:
                     break;
               }
            }
         }
      });

      // let i = 0;
      // filters.forEach(filter => {
      //    alert('filter' + (i++) + '=' + JSON.stringify(filter));

      //    if (filter.$match) {
      //       alert(JSON.stringify(actualData));
      //       // collection = new Collection(actualData);
      //       collection = jsonAggregate.create(actualData);
      //       alert('after collection');
      //       actualData = collection.match(filter.$match).exec();
      //       alert('after actualData');
      //    } else if (filter.$group) {
      //       alert('in group');
      //       collection = new Collection(actualData);
      //       actualData = collection.group(filter.$group).exec();
      //    }
      // });
   }

   // alert('actualData=' + JSON.stringify(actualData));
   return actualData;
}

function _parseIndexData(responseData) {
   _log('in _parseIndexData(): responseData=' + JSON.stringify(responseData));
   const resultData = [];

   Object.keys(responseData).forEach(key => {
      const val = responseData[key];
      // alert(`key=${key}, val=${JSON.stringify(val)}`);
      const index = {
         fieldName1: val[0][0],
         sortOrder1: val[0][1]
      };

      if (val.length > 1) {
         index.fieldName2 = val[1][0];
         index.sortOrder2 = val[1][1];
      } else {
         index.fieldName2 = '';
         index.sortOrder2 = -1;
      }

      index.unique = false;
      index.name = key;
      resultData.push(index);
   });

   return resultData;
}

export class APIService {

   constructor(jwt, token, debug, isActualEndpoint) {
      // alert('in APIService: token=' + token + '\ndebug=' + debug + '\nisActualEndpoint=' + isActualEndpoint);
      _debug = debug;
      this.jwt = jwt;
      this.isActualEndpoint = isActualEndpoint;
      this.$http = axios.create({
         baseURL: process.env.VUE_APP_EDGE_SERVICE_ENDPOINT + (isActualEndpoint ? '/api/contact-service/v1' : ''),
         headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
         }
      });
   }

   /****************************************************/
   /*        CONFIGURATION : not in use anymore        */
   /****************************************************/

   async getConfig(aid) {
      _log('getConfig() started: aid=' + aid);
      let result = _initResult();

      // await sleep(2000);

      try {
         let url = '/accounts';
         if (this.isActualEndpoint) url += '/' + aid;
         else url += '?accountId=' + aid;

         let response = await this.$http.get(url);
         _log(`response=${JSON.stringify(response)}`);

         if (Array.isArray(response.data)) {
            if (response.data.length > 0)
               result.data = response.data[0];
            else
               result.data = {};
         } else
            result.data = response.data;
      } catch (error) {
         // if (error.response.status == 404)
         //    result.data = [];
         // else
         //    result.message = _parseError(error);
         result = _parseError(error, []);
      }

      return result;
   }

   async createConfig(aid, config) {
      _log('createConfig(): aid=' + aid + ', config=' + JSON.stringify(config));
      let result = _initResult();

      try {
         if (!this.isActualEndpoint)
            config.accountId = aid;

         const response = await this.$http.post('/accounts', config);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         // result.message = _parseError(error);
         result = _parseError(error);
      }

      return result;
   }

   async updateConfig(aid, config, id) {
      _log('updateConfig(): aid=' + aid + ', config=' + JSON.stringify(config) + ', id=' + id);
      let result = _initResult();

      try {
         if (!this.isActualEndpoint) {
            config.accountId = aid;
            config._id = id;
         }

         const response = await this.$http.put(`/accounts/${id}`, config);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         // result.message = _parseError(error);
         result = _parseError(error);
         //Request failed with status code 401
      }

      return result;
   }

   /********************************/
   /*            IMPORTS           */
   /********************************/

   async getImportsCount(filter) {
      _log(`in getImportsCount(): filter=${JSON.stringify(filter)}`);
      let result = _initResult();

      try {
         let url = '/imports?';
         if (this.isActualEndpoint)
            url += `find=${JSON.stringify(filter.standard)}&count=`;
         else
            url += `accountId=${this.jwt.aid}${_parseMatchFilter(filter)}&_limit=1`;

         // alert('in getImportsCount(): url=' + url);

         const response = await this.$http.get(url);
         _log(`response=${JSON.stringify(response)}`);
         if (this.isActualEndpoint)
            result.data = response.data.count;
         else
            result.data = parseInt(response.headers['x-total-count']);
      } catch (error) {
         // if (error.response.status == 404)
         //    result.data = [];
         // else
         //    result.message = _parseError(error);
         result = _parseError(error, []);
      }

      return result;
   }

   async getImports(filter, limit, page) {
      _log(`in getImports(): filter=${JSON.stringify(filter)}\n\nlimit=${limit}, page=${page}`);
      let result = _initResult();
      // await sleep(2000);

      try {
         let url = '/imports';
         if (this.isActualEndpoint) {
            const skip = page ? (page - 1) * limit : 0;
            url += `?find=${JSON.stringify(filter.standard)}&limit=${limit}&skip=${skip}` +
               (filter.sort ? '&sort=' + JSON.stringify(filter.sort) : '');
         } else {
            url += '?accountId=' + this.jwt.aid + _parseMatchFilter(filter) +
               '&_limit=' + limit + '&_page=' + (page || 1);

            if (filter.sort) {
               const sort = Object.keys(filter.sort)[0];
               const order = filter.sort[sort] === 1 ? 'asc' : 'desc';
               url += `&_sort=${sort}&_order=${order}`;
            } else
               url += '&_sort=creationDate&_order=desc';
         }

         // alert('in getImports(): url=' + url);

         const response = await this.$http.get(url);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         // if (error && error.response && error.response.status == 404)
         //    result.data = [];
         // else
         //    result.message = _parseError(error);
         result = _parseError(error, []);
      }

      return result;
   }

   async getImport(importId) {
      _log('getImport(): importId=' + importId);
      let result = _initResult();

      try {
         let url = '/imports/' + importId;

         const response = await this.$http.get(url);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         // result.message = _parseError(error);
         result = _parseError(error);
      }

      return result;
   }

   async createImport(importData) {
      _log('createImport(): importData=' + JSON.stringify(importData));
      let result = _initResult();

      try {
         if (!this.isActualEndpoint) {
            const now = new Date();
            const date = now.getFullYear() + '-' + (now.getMonth() + 1).toString().padStart(2, "0") + '-' + now.getDate().toString().padStart(2, "0") + 'T' + 
               now.getHours().toString().padStart(2, "0") + ":" + now.getMinutes().toString().padStart(2, "0") + ':' + now.getSeconds().toString().padStart(2, "0") + '.' + now.getMilliseconds().toString().padStart(3, "0") + 'Z';
            importData.accountId = this.jwt.aid;
            importData.databaseName = 'DB-' + this.jwt.aid;
            importData.recoveryCount = 0;
            importData.recoveryError = '';
            importData.creationDate = date;
            // "startDate": "2020-11-05T22:00:00.000Z",
            // importData.lastActivityDate = date;
            importData.processedRecords = 0;
            importData.status = 'waiting';
         }

         const response = await this.$http.post('/imports', importData);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         // result.message = _parseError(error);
         result = _parseError(error);
      }

      return result;
   }

   async updateImport(importData) {
      _log('in updateImport(): import=' + JSON.stringify(importData));
      let result = _initResult(importData);

      try {
         if (!this.isActualEndpoint) {
            const now = new Date();
            const date = now.getFullYear() + '-' + (now.getMonth() + 1).toString().padStart(2, "0") + '-' + now.getDate().toString().padStart(2, "0") + 'T' + 
               now.getHours().toString().padStart(2, "0") + ":" + now.getMinutes().toString().padStart(2, "0") + ':' + now.getSeconds().toString().padStart(2, "0") + '.' + now.getMilliseconds().toString().padStart(3, "0") + 'Z';
            importData.status = 'rejected';
            importData.recoveryError = 'cancelled by the user';
            // "startDate": "2020-11-05T22:00:00.000Z",
            importData.lastActivityDate = date;
         }

         const response = await this.$http.put(`/imports/${importData._id}`, importData);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         // result.message = _parseError(error);
         result = _parseError(error);
      }

      return result;
   }

   /********************************/
   /*            EXPORTS           */
   /********************************/

   async getExportsCount(filter) {
      _log(`in getExportsCount(): filter=${JSON.stringify(filter)}`);
      let result = _initResult();

      try {
         let url = '/exports?';
         if (this.isActualEndpoint)
            url += `find=${JSON.stringify(filter.standard)}&count=`;
         else
            url += `accountId=${this.jwt.aid}${_parseMatchFilter(filter)}&_limit=1`;

         // alert('in getExportsCount(): url=' + url);

         const response = await this.$http.get(url);
         _log(`response=${JSON.stringify(response)}`);
         if (this.isActualEndpoint)
            result.data = response.data.count;
         else
            result.data = parseInt(response.headers['x-total-count']);
      } catch (error) {
         // if (error.response.status == 404)
         //    result.data = [];
         // else
         //    result.message = _parseError(error);
         result = _parseError(error, []);
      }

      return result;
   }

   async getExports(filter, page, limit) {
      _log('in getExports(): filter=' + JSON.stringify(filter) + '\npage=' + page + ', limit=' + limit);
      let result = _initResult();
      // await sleep(2000);

      try {
         let url = '/exports';
         if (this.isActualEndpoint) {
            url += `?find=${JSON.stringify(filter.standard)}&limit=${limit}&skip=${(page - 1) * limit}` +
               (filter.sort ? '&sort=' + JSON.stringify(filter.sort) : '');
         } else {
            url += '?accountId=' + this.jwt.aid + _parseMatchFilter(filter) +
               '&_limit=' + limit + '&_page=' + page;

            if (filter.sort) {
               const sort = Object.keys(filter.sort)[0];
               const order = filter.sort[sort] === 1 ? 'asc' : 'desc';
               url += `&_sort=${sort}&_order=${order}`;
            } else
               url += '&_sort=creationDate&_order=desc';
         }
         // alert('in getExports(): url=' + url);

         const response = await this.$http.get(url);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         // if (error && error.response && error.response.status == 404)
         //    result.data = [];
         // else
         //    result.message = _parseError(error);
         result = _parseError(error, []);
      }

      return result;
   }

   async getExport(exportId) {
      _log('getExport(): exportId=' + exportId);
      let result = _initResult();

      try {
         let url = '/exports/' + exportId;

         const response = await this.$http.get(url);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         // result.message = _parseError(error);
         result = _parseError(error);
      }

      return result;
   }

   async getExportUrl(exportId) {
      _log('getExportUrl(): exportId=' + exportId);
      let result = _initResult();

      try {
         if (this.isActualEndpoint) {
            let url = '/downloads/' + exportId;
            const response = await this.$http.get(url);
            _log(`response=${JSON.stringify(response)}`);
            result.data = response.data;
         } else
            result.data = { url: 'https://behzad-mindfire-bucket.s3.us-west-2.amazonaws.com/suppressedList/SuppressedList1.csv' };
      } catch (error) {
         // result.message = _parseError(error);
         result = _parseError(error);
      }

      return result;
   }

   async createExport(exportData) {
      _log('createImport(): exportData=' + JSON.stringify(exportData));
      let result = _initResult();

      try {
         if (!this.isActualEndpoint) {
            const now = new Date();
            const date = now.getFullYear() + '-' + (now.getMonth() + 1).toString().padStart(2, "0") + '-' + now.getDate().toString().padStart(2, "0") + 'T' + 
               now.getHours().toString().padStart(2, "0") + ":" + now.getMinutes().toString().padStart(2, "0") + ':' + now.getSeconds().toString().padStart(2, "0") + '.' + now.getMilliseconds().toString().padStart(3, "0") + 'Z';
            exportData.accountId = this.jwt.aid;
            exportData.databaseName = 'DB-' + this.jwt.aid;
            exportData.recoveryCount = 0;
            exportData.recoveryError = '';
            exportData.creationDate = date;
            exportData.processedRecords = 0;
            exportData.status = 'waiting';
            exportData.startDate = '';
            exportData.lastActivityDate = '';
         }

         const response = await this.$http.post('/exports', exportData);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         // result.message = _parseError(error);
         result = _parseError(error);
      }

      return result;
   }

   /********************************/
   /*            INDEXES           */
   /********************************/

   async getIndexes() {
      _log('in getIndexes()...');
      let result = _initResult();

      // await sleep(2000);

      try {
         let url = '/indexes';
         if (!this.isActualEndpoint) {
            url += '?accountId=' + this.jwt.aid;// + '&_sort=_id&_order=desc';
         }

         const response = await this.$http.get(url);
         _log(`response=${JSON.stringify(response)}`);

         if (this.isActualEndpoint) {
            result.data = _parseIndexData(response.data);
         } else {
            // response.data = {
            //    "_id_":[["_id",1]],
            //    "purlNumber_-1":[["purlNumber",-1]],
            //    "dedupHash_1":[["dedupHash",1]],
            //    "importId_1":[["importId",1]],
            //    "basePurl_1":[["basePurl",1]],
            //    "events_-1":[["events",-1]],
            //    "location_2d":[["location","2d"]],
            //    "cIndex_product-asc":[["product",1]],
            //    "cIndex_product_-1_payment_type_-1":[["product",-1],["payment_type",-1]]
            // };
            // result.data = _parseIndexData(response.data);
            result.data = response.data;
         }
      } catch (error) {
         // if (error.response.status == 404)
         //    result.data = [];
         // else
         //    result.message = _parseError(error);
         result = _parseError(error, []);
      }

      return result;
   }

   async createIndex(indexData) {
      _log('in createImport(): indexData=' + JSON.stringify(indexData));
      let result = _initResult();

      try {
         const url = '/indexes';
         let postData;
         if (this.isActualEndpoint) {
            let fields = {};
            fields[indexData.fieldName1] = indexData.sortOrder1;
            if (indexData.fieldName2)
               fields[indexData.fieldName2] = indexData.sortOrder2;
            postData = [
               fields, 
               { 
                  background: true, 
                  unique: indexData.unique, 
                  name: 'cIndex_' + indexData.name 
               }
            ];
         }
         else {
            postData = JSON.parse(JSON.stringify(indexData));
            postData.name = 'cIndex_'+ postData.name;
            postData.accountId = this.jwt.aid;
            // alert('postData=' + JSON.stringify(postData));
         }

         const response = await this.$http.post(url, postData);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         // result.message = _parseError(error);
         result = _parseError(error);
      }

      return result;
   }

   async deleteIndex(indexData) {
      _log('in deleteIndex(): indexData=' + JSON.stringify(indexData));
      let result = _initResult();

      try {
         let url = '/indexes/';
         if (this.isActualEndpoint) {
            let fields = {};
            fields[indexData.fieldName1] = indexData.sortOrder1;
            if (indexData.fieldName2)
               fields[indexData.fieldName2] = indexData.sortOrder2;
            url += JSON.stringify(fields);
         } else {
            url += indexData._id;
         }
         
         _log('url=' + url);
         const response = await this.$http.delete(url);
         _log(`response=${JSON.stringify(response)}`);
         result.data = await response.data;
      } catch (error) {
         // result.message = _parseError(error);
         result = _parseError(error);
      }

      return result;
   }

   /********************************/
   /*      OFFERS (DOCUMENTS)      */
   /********************************/

   async getOffersCount(filter) {
      _log(`in getOffersCount(): original filter=${JSON.stringify(filter)}`);
      let result = _initResult();
      try {
         let url = '/offers?';
         if (this.isActualEndpoint) {
            //fine-tuning the filter to be executed fater
            let modifiedFilter;
            if (filter.standard.length > 1 || Object.keys(filter.standard[0].$match).length)
               modifiedFilter = filter;
            else {
               modifiedFilter = JSON.parse(JSON.stringify(filter));
               modifiedFilter.standard[0].$match = {_id: { $ne: null}};
            }
            _log(`in getOffersCount(): modified filter=${JSON.stringify(modifiedFilter)}`);

            const addFields = modifiedFilter.standard.find(f => f.hasOwnProperty('$addFields'));
            if (addFields) {
               const aggregate = [
                  addFields,
                  modifiedFilter.standard.find(f => f.hasOwnProperty('$match')),
                  { $count: "count" }
               ];
               url += `aggregate=${JSON.stringify(aggregate)}`;
            } else
               url += `find=${JSON.stringify(modifiedFilter.standard)}&count=`;
         } else
            url += `accountId=${this.jwt.aid}${_parseMatchFilter(filter)}&_limit=1`;

         // alert('url=' + url);

         const response = await this.$http.get(url);
         _log(`response=${JSON.stringify(response)}`);
         if (this.isActualEndpoint)
            result.data = Array.isArray(response.data) ? response.data[0].count : response.data.count;
         else
            result.data = parseInt(response.headers['x-total-count']);
      } catch (error) {
         // if (error.response.status == 404)
         //    result.data = [];
         // else
         //    result.message = _parseError(error);
         result = _parseError(error, []);
      }

      return result;
   }

   async getLastOffer() {
      _log('in getLastOffer()');
      let result = _initResult();

      try {
         let url = '/offers';
         if (this.isActualEndpoint)
            url += `?limit=1&skip=0`;
         else
            url += '?accountId=' + this.jwt.aid + '&_sort=creationDate&_order=desc&_limit=1';

         // alert('url=' + url);

         const response = await this.$http.get(url);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         // if (error.response.status == 404)
         //    result.data = [];
         // else
         //    result.message = _parseError(error);
         result = _parseError(error, []);
      }

      return result;
   }

   async getOffers(filter, page, limit) {
      _log(`in getOffers(): page=${page}, limit=${limit}\nfilter=${JSON.stringify(filter)}`);
      let result = _initResult();

      // await sleep(2000);

      try {
         let url = '/offers';
         if (this.isActualEndpoint) {
            const skip = page ? (page - 1) * limit : 0;
            const columns = [...filter.columns, '_id'];
            if (filter.standard.filter(f => f.$group).length === 1)
               url += `?aggregate=${JSON.stringify(filter.standard)}`;
            else {
               const addFields = filter.standard.find(f => f.hasOwnProperty('$addFields'));
               if (addFields) {
                  const project = {};
                  columns.forEach(column => {
                     project[column] = 1;
                  });
                  // ...(filter.sort && { $sort: filter.sort }),
                  const aggregate = [
                     addFields,
                     filter.standard.find(f => f.hasOwnProperty('$match'))
                  ];
                  if (filter.sort)
                     aggregate.push({ $sort: filter.sort });
                  aggregate.push(
                     { $skip: skip },
                     { $limit: limit },
                     { $project: project }
                  );
                  url += `?aggregate=${JSON.stringify(aggregate)}`;
               } else {
                  url += `?skip=${skip}&find=${JSON.stringify(filter.standard)}&select=${columns.join(' ')}` +
                     (filter.sort ? '&sort=' + JSON.stringify(filter.sort) : '') + 
                     (limit ? `&limit=${limit}` : '');
               }
            }
         } else {
            url += '?accountId=' + this.jwt.aid + _parseMatchFilter(filter) +
               '&_page=' + (page ? page : 1) + (limit ? '&_limit=' + limit : ''); 

            if (filter.sort) {
               const sort = Object.keys(filter.sort)[0];
               const order = filter.sort[sort] === 1 ? 'asc' : 'desc';
               url += `&_sort=${sort}&_order=${order}`;
            } else
               url += '&_sort=creationDate&_order=desc';
         }

         // alert('url=' + url);

         const response = await this.$http.get(url);
         _log(`response=${JSON.stringify(response)}`);
         if (this.isActualEndpoint)
            result.data = [...response.data];
         else
            result.data = _getActualData(response.data, filter);
      } catch (error) {
         // if (error.response && error.response.status && error.response.status == 404)
         //    result.data = [];
         // else
         //    result.message = _parseError(error);
         result = _parseError(error, []);
      }

      return result;
   }

   async getOffer(offerId) {
      _log('getOffer(): offerId=' + offerId);
      let result = _initResult();

      // await sleep(3000);

      try {
         let url = '/offers/' + offerId;

         const response = await this.$http.get(url);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         // result.message = _parseError(error);
         result = _parseError(error);
      }

      return result;
   }

   async deleteOffers(filter, deletedCount) {
      _log('in deleteOffers(): filter=' + JSON.stringify(filter));
      let result = _initResult();

      try {
         if (this.isActualEndpoint) {
            const postData = {
               data: { filter: filter.standard, deletedRecords: deletedCount }
            };
            const response = await this.$http.delete('/offers', postData);
            _log(`response=${JSON.stringify(response)}`);
            result.data = await response.data.deletedCount;
         } else {
            await sleep(20000);
            result.data = deletedCount;
         }
      } catch (error) {
         // result.message = _parseError(error);
         result = _parseError(error);
      }

      return result;
   }

   /********************************/
   /*           DELETES            */
   /********************************/

   async getDeletesCount(filter) {
      _log(`in getDeletesCount(): filter=${JSON.stringify(filter)}`);
      let result = _initResult();
      
      try {
         let url = '/deletes?';
         if (this.isActualEndpoint)
            url += `find=${JSON.stringify(filter.standard)}&count=`;
         else
            url += `accountId=${this.jwt.aid}${_parseMatchFilter(filter)}&_limit=1`;

         // alert('url=' + url);

         const response = await this.$http.get(url);
         _log(`in getDeletesCount(): response=${JSON.stringify(response)}`);
         if (this.isActualEndpoint)
            result.data = Array.isArray(response.data) ? response.data[0].count : response.data.count;
         else {
            await sleep(5000);
            result.data = parseInt(response.headers['x-total-count']);
         }
      } catch (error) {
         // if (error.response.status == 404)
         //    result.data = 0;
         // else
         //    result.message = _parseError(error);
         result = _parseError(error, 0);
      }

      return result;
   }

   async getDeletes(filter, page, limit) {
      _log(`in getDeletes(): page=${page}, limit=${limit}\n\tfilter=${JSON.stringify(filter)}`);
      let result = _initResult();

      // await sleep(2000);

      try {
         let url = '/deletes';
         if (this.isActualEndpoint) {
            const skip = page ? (page - 1) * limit : 0;
            url += `?skip=${skip}&find=${JSON.stringify(filter.standard)}` +
               (filter.sort ? '&sort=' + JSON.stringify(filter.sort) : '') + 
               (limit ? `&limit=${limit}` : '');
         } else {
            url += '?accountId=' + this.jwt.aid + _parseMatchFilter(filter) +
               '&_page=' + (page ? page : 1) + (limit ? '&_limit=' + limit : ''); 

            if (filter.sort) {
               const sort = Object.keys(filter.sort)[0];
               const order = filter.sort[sort] === 1 ? 'asc' : 'desc';
               url += `&_sort=${sort}&_order=${order}`;
            } else
               url += '&_sort=creationDate&_order=desc';
         }

         // alert('url=' + url);

         const response = await this.$http.get(url);
         _log(`in getDeletes(): response=${JSON.stringify(response)}`);
         // result.data = [...response.data];
         result.data = response.data;
      } catch (error) {
         // if (error.response && error.response.status && error.response.status == 404)
         //    result.data = [];
         // else
         //    result.message = _parseError(error);
         result = _parseError(error, []);
      }

      return result;
   }

   /********************************/
   /*       REMOTE ACCESSES        */
   /********************************/

   async getRemoteAccessesCount(filter) {
      _log(`in getRemoteAccessesCount(): filter=${JSON.stringify(filter)}`);
      let result = _initResult();

      try {
         let url = '/remoteAccess?';
         if (this.isActualEndpoint)
            url += `find=${JSON.stringify(filter.standard)}&count=`;
         else
            url += `accountId=${this.jwt.aid}${_parseMatchFilter(filter)}&_limit=1`;

         // alert('in getImportsCount(): url=' + url);

         const response = await this.$http.get(url);
         _log(`response=${JSON.stringify(response)}`);
         if (this.isActualEndpoint)
            result.data = response.data.count;
         else
            result.data = parseInt(response.headers['x-total-count']);
      } catch (error) {
         // if (error.response.status == 404)
         //    result.data = 0;
         // else
         //    result.message = _parseError(error);
         result = _parseError(error, 0);
      }

      return result;
   }

   async getRemoteAccesses(filter, limit, page) {
      _log(`in getRemoteAccesses(): filter=${JSON.stringify(filter)}\n\nlimit=${limit}, page=${page}`);
      let result = _initResult();
      // await sleep(2000);

      try {
         let url = '/remoteAccess';
         if (this.isActualEndpoint) {
            const skip = page ? (page - 1) * limit : 0;
            url += `?find=${JSON.stringify(filter.standard)}&limit=${limit}&skip=${skip}` +
               (filter.sort ? '&sort=' + JSON.stringify(filter.sort) : '');
         } else {
            url += '?accountId=' + this.jwt.aid + _parseMatchFilter(filter) +
               '&_limit=' + limit + '&_page=' + (page || 1);

            if (filter.sort) {
               const sort = Object.keys(filter.sort)[0];
               const order = filter.sort[sort] === 1 ? 'asc' : 'desc';
               url += `&_sort=${sort}&_order=${order}`;
            } else
               url += '&_sort=creationDate&_order=desc';
         }

         // alert('in getImports(): url=' + url);

         const response = await this.$http.get(url);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         // if (error && error.response && error.response.status == 404)
         //    result.data = [];
         // else
         //    result.message = _parseError(error);
         result = _parseError(error, []);
      }

      return result;
   }

   async createRemoteAccess(accessData) {
      _log('createRemoteAccess(): accessData=' + JSON.stringify(accessData));
      let result = _initResult();

      try {
         if (!this.isActualEndpoint) {
            const now = new Date();
            const date = now.getFullYear() + '-' + (now.getMonth() + 1).toString().padStart(2, "0") + '-' + now.getDate().toString().padStart(2, "0") + 'T' + 
               now.getHours().toString().padStart(2, "0") + ":" + now.getMinutes().toString().padStart(2, "0") + ':' + now.getSeconds().toString().padStart(2, "0") + '.' + now.getMilliseconds().toString().padStart(3, "0") + 'Z';
            accessData.accountId = this.jwt.aid;
            accessData.creationDate = date;
         }

         const response = await this.$http.post('/remoteAccess', accessData);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         // result.message = _parseError(error);
         result = _parseError(error);
      }

      return result;
   }

   async updateRemoteAccess(item, accessData) {
      _log(`in updateRemoteAccess(): item=${JSON.stringify(item)}, accessData=${JSON.stringify(accessData)}`);
      let result = _initResult();

      try {
         if (!this.isActualEndpoint) {
            accessData.accountId = item.accountId;
            accessData.creationDate = item.creationDate;
            accessData._id = item._id;
         }

         const response = await this.$http.put(`/remoteAccess/${item._id}`, accessData);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         // result.message = _parseError(error);
         result = _parseError(error);
      }

      return result;
   }

   async deleteRemoteAccess(id) {
      _log('in deleteRemoteAccess(): id=' + id);
      let result = _initResult();

      try {
         const response = await this.$http.delete('/remoteAccess/' + id);
         _log(`response=${JSON.stringify(response)}`);
         result.data = await response.data;
      } catch (error) {
         // result.message = _parseError(error);
         result = _parseError(error);
      }

      return result;
   }

   /********************************/
   /*      PREDEFINED FILTERS      */
   /********************************/

   async getPredefinedFilters() {
      _log(`in getPredefinedFilters()`);
      let result = _initResult();

      try {
         let url = '/rdls';
         if (!this.isActualEndpoint) {
            url += '?accountId=' + this.jwt.aid;// + '&_sort=_id&_order=desc';
         }

         // alert('in getPredefinedFilters(): url=' + url);

         const response = await this.$http.get(url);
         _log(`response=${JSON.stringify(response)}`);
         result.data = [...response.data];
      } catch (error) {
         // if (error.response && error.response.status && error.response.status == 404)
         //    result.data = [];
         // else
         //    result.message = _parseError(error);
         result = _parseError(error, []);
      }

      return result;
   }

   async getPredefinedFilter(id) {
      _log(`in getPredefinedFilter(): id=${id}`);
      let result = _initResult();

      try {
         const response = await this.$http.get(`/rdls/${id}`);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         // if (error.response && error.response.status && error.response.status == 404)
         //    result.data = {};
         // else
         //    result.message = _parseError(error);
         result = _parseError(error, {});
      }

      return result;
   }

   async createPredefinedFilter(postData) {
      _log('createPredefinedFilter(): postData=' + JSON.stringify(postData));
      let result = _initResult();

      try {
         if (!this.isActualEndpoint) {
            postData.accountId = this.jwt.aid;
         }

         const response = await this.$http.post('/rdls', postData);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         // result.message = _parseError(error);
         result = _parseError(error);
      }

      return result;
   }

   async updatePredefinedFilter(id, putData) {
      _log(`in updatePredefinedFilter(): id=${id}, putData=${JSON.stringify(putData)}`);
      let result = _initResult();

      try {
         if (!this.isActualEndpoint) {
            putData._id = id;
            putData.accountId = this.jwt.aid;
         }

         const response = await this.$http.put(`/rdls/${id}`, putData);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         // result.message = _parseError(error);
         result = _parseError(error);
      }

      return result;
   }

   async deletePredefinedFilter(id) {
      _log('in deletePredefinedFilter(): id=' + id);
      let result = _initResult();

      try {
         const response = await this.$http.delete('/rdls/' + id);
         _log(`response=${JSON.stringify(response)}`);
         // result.data = response.data;
      } catch (error) {
         // result.message = _parseError(error);
         result = _parseError(error);
      }

      return result;
   }

}